var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/search-normal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-normal_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.66634 14.4997C3.89967 14.4997 0.833008 11.433 0.833008 7.66634C0.833008 3.89967 3.89967 0.833008 7.66634 0.833008C11.433 0.833008 14.4997 3.89967 14.4997 7.66634C14.4997 11.433 11.433 14.4997 7.66634 14.4997ZM7.66634 1.83301C4.44634 1.83301 1.83301 4.45301 1.83301 7.66634C1.83301 10.8797 4.44634 13.4997 7.66634 13.4997C10.8863 13.4997 13.4997 10.8797 13.4997 7.66634C13.4997 4.45301 10.8863 1.83301 7.66634 1.83301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.6666 15.1666C14.54 15.1666 14.4133 15.12 14.3133 15.02L12.98 13.6866C12.7866 13.4933 12.7866 13.1733 12.98 12.98C13.1733 12.7866 13.4933 12.7866 13.6866 12.98L15.02 14.3133C15.2133 14.5066 15.2133 14.8266 15.02 15.02C14.92 15.12 14.7933 15.1666 14.6666 15.1666Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.22f8b6e773bd292e78635ce181d26e96.svg";
export { ForwardRef as ReactComponent };